import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'subscriptionTypesFilter', namespaced: true })
export default class SubscriptionTypesFilter extends FilterModule {
    constructor(module: SubscriptionTypesFilter) {
        super(module);
    }
}
